import { Component, ElementRef, EventEmitter, Input, OnChanges, OnInit, Output, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { saveAs } from 'file-saver';
import { finalize } from 'rxjs/operators';
import { ToastService } from 'src/app/core';
import {
  CandidateApi, CandidateDocuments,
  DocumentType, ImmigrationApi,
  ImmigrationDocCombined,
  ImmigrationDocument,
  ImmigrationProfile, LookupField
} from 'src/app/core/api.gen';
import { AuthService } from 'src/app/core/auth.service';
import { NgForm } from '@angular/forms';
import { LookupTypeKeys } from '../lookup-type-keys';
import { CommonService } from 'src/app/core/common.service';
import { DialogService } from 'src/app/core/dialog.service';
import { DocumentUploadService } from 'src/app/core/document-upload.service';
import { LoaderService } from 'src/app/core/loader.service';
import { OpenFilePreviewService } from 'src/app/core/open-file-preview.service';
import { DocTypes } from './doc-types';
import { ImmigrationDataPopulationService } from 'src/app/immigration/services/data-population/ImmigrationDataPopulation.service';
import { textEllipsis } from 'src/app/utils/helper-text';
import { Logger } from 'src/app/utils/Logger';
import { isNullOrUndefined } from '../../../app/core/utils';
import { ShareDocumentService } from '../../core/share-document.service';
import { GeneralMail } from '../configurable-mail/general-mail-model';
import { ImmigrationStatusTypes } from '../immigration-status-types';
import { AllowedDocumentFormat, DocumentValidationMessage, ModuleTypes, ValidationDocType } from '../module-types';
import { nullSafe, nullSafeValue } from 'src/app/utils';
import { AdditionalInfo, DocumentConfigLookupMapping, DocumentInstructions, EmailApi, ImmigrationCandidate, ImmigrationComment, ImmigrationDatapullApi } from './../../core/api.gen';
import { CountryTypesValues } from '../../immigration/services/visatypes/country-types.enum';


@Component({
  selector: 'eos-immigration-file-upload',
  templateUrl: './immigration-file-upload.component.html',
  styleUrls: ['./file-upload.component.css']
})
export class ImmigrationFileUploadComponent implements OnInit, OnChanges {

  docnamePattern = "^[a-zA-Z0-9 ]*$";
  @Input() lookupType: number = LookupTypeKeys.IMMIGRATION_DOCUMENT_TYPES;
  @Input() readonly: boolean;
  @Input() visaType: string;
  @Input() countryType: string;
  @Input() candidateForm;
  @Input() ImmCaseType: number;
  @Input() filter: AdditionalInfo;
  @Input() isVisaApprover: boolean;
  @Input() isApproverDocs: boolean;
  @Input() model: ImmigrationProfile;
  @Input() showingFileUpload = false;
  @Input() moduleType = DocTypes.REQUESTER_DOC;
  @Input() isAdditionalUpload = false;
  @Input() ImmigrationProfileId = 0;
  ImmigrationStatusTypes = ImmigrationStatusTypes;
  @ViewChild('fileField') element: ElementRef;
  @ViewChild('fileControl') fileEle: ElementRef;

  @ViewChild('f') form: NgForm;
  documentList: DocumentType[] = [];
  documentInstructions: DocumentInstructions[] = [];
  distinctDocTypes: DocumentType[];
  selectedDocName: DocumentType | any = null;
  fileDetails: any;
  allFiles: ImmigrationDocCombined[] = [];
  gridFiles: ImmigrationDocCombined[] = [];
  selectedDocument: File;
  disableUpload = false;
  editMode = false;
  showUpload = true;
  docName: string;
  docType: string;
  docInstruction: string;
  showSpinner = false;
  showFormSpinner = false;
  ableToSync = true;
  cicpavisa = false;
  isEmiratesID = false;
  showDownloadDocSpinner = false;
  checkDocType: number;
  validationList: DocumentValidationMessage[] = [];
  TMT_Check_Status: string;
  isCollapsed = false;
  taskDocList = [];
  activityId: number;
  uploadedCount: number = 0;
  pendingCount: number = 0;
  pendingAllCount: number = 0;
  totalCount: number = 0;
  selectedTab: number = 1;
  allDoc: boolean = false;
  uploadedDoc: boolean = false;
  pendingDoc: boolean = false;
  isMandatoryChecked: boolean = false;

  readonly UaeAllowedMimeTypes: string[] = [
    'image/jpeg'
    , 'image/jpg'
    , 'application/pdf'
    , 'image/png'
    , 'application/msword'
    , 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
    , 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    , 'application/vnd.ms-excel'
  ];

  readonly allowedMimeTypes = [
    'application/pdf'
    , 'image/jpeg'
    , 'image/png'
    , 'application/msword'
    , 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
    , 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    , 'application/vnd.ms-excel'
  ];

  readonly MAX_FILE_SIZE: number = 10 * 1024 * 1024;
  readonly MIN_FILE_SIZE: number = 1 * 1024;

  @Output() GetDocumentEvent = new EventEmitter<ImmigrationDocCombined[]>();
  @Output() validDocuments = new EventEmitter<LookupField[]>();
  @Output() fileUploaded = new EventEmitter<number>();

  miscellaneous = 'miscellaneous';
  emailShare: GeneralMail = new GeneralMail();
  attachmentShared = [];
  shouldUpdateFileInput: boolean;

  constructor(
    private common: CommonService,
    private fileUploadService: DocumentUploadService,
    private candidateApi: CandidateApi,
    private route: ActivatedRoute,
    private toast: ToastService,
    public authService: AuthService,
    private dialog: DialogService,
    private openfilepreview: OpenFilePreviewService,
    private immigrationApi: ImmigrationApi,
    private immigrationDatapull: ImmigrationDatapullApi,
    private loader: LoaderService,
    private ImmigrationDataPopulation: ImmigrationDataPopulationService,
    private emailAPI: EmailApi,
    public modal: NgbActiveModal,
    private shareDocService: ShareDocumentService,
    private modalService: NgbModal,
    private router: Router
  ) {
    this.fileDetails = new CandidateDocuments();
    this.fileDetails.documentTypeId = null;
    this.fileDetails.documentNameId = null;
  }


  ngOnChanges() {
    if (!this.isAdditionalUpload) {
      if (this.model.id > 0
        && this.showingFileUpload) {
        this.getImmigrationDocuments();
        // this.getDocumentTypes();
        //this.getDocumentInstructions();
        //this.getUploadedFileDetails(this.common.immigrationProfileId);
        this.validationList = [];
      }
    } else {
      this.getImmigrationDocuments();
      //this.getDocumentTypes();
    }

  }

  ngOnInit() {
    if (this.lookupType === LookupTypeKeys.IMMIGRATION_DOCUMENT_TYPES) {
      this.docType = "Download Immigration documents";
    } else {
      this.docType = "Download all";
    }
    this.cicpavisa = this.visaType === 'ARE-CicpaCard';
    this.isEmiratesID = ['ARE-DepVisaGccMarriedToExpat', 'ARE-DependentsVisaIssuance', 'ARE-DependentsVisaRenewal'].includes(this.visaType);
    // this.getDocumentTypes();

    this.route.params.subscribe(data => {

      if (data.id && data.id > 0) {
        this.common.immigrationProfileId = data.id;
        //this.getUploadedFileDetails(data.id);
        this.getImmigrationDocuments();
        //this.GetDocumentEvent.emit(this.uploadedFiles);

      }
      if (data.activityId && data.activityId > 0) {
        this.activityId = data.activityId;
        this.getImmActivitydetails();
      }

    });


  }

  getImmActivitydetails() {
    this.immigrationApi.getImmActivityById(this.activityId)
      .subscribe(activity => {
        if (activity?.propertyExtensions && this.common.isStringValidJson(activity?.propertyExtensions)) {
          const Pextension = JSON.parse(activity?.propertyExtensions);
          if (Pextension && Pextension?.DocumentId) {
            this.taskDocList = Pextension?.DocumentId;

          }
        }
      });


  }

  multipleDocsShare() {
    // if (this.moduleType == DocTypes.REQUESTER_DOC) {
    this.attachmentShared = this.shareDocService.changeDocumentName(this.allFiles.filter(x => x.isUploaded), ModuleTypes.Immigration);
    if (!this.shareDocService.isFileAvailable(this.attachmentShared)) {
      return;
    }
    this.multiDocShareFn();
    // } else {
    //   this.immigrationApi.getAllDocumentDetails(this.common.immigrationProfileId)
    //     .subscribe(resp => {
    //       if (!this.shareDocService.isFileAvailable(resp)) {
    //         return;
    //       }
    //       resp = this.shareDocService.changeDocumentName(resp, ModuleTypes.Immigration);
    //       this.attachmentShared = resp;
    //       this.multiDocShareFn();
    //     });
    // }
  }

  multiDocShareFn() {
    this.loader.show();
    this.emailAPI.getEmailMessageByCode("ShareDocument-IMM").pipe(finalize(() => {
      this.loader.clear();
    })).subscribe(em => {
      this.emailShare = this.shareDocService.mapToGeneralMail(em);
      this.emailShare.uploadedFiles = [];
      this.dialog.docShareMail(this.emailShare, (email) => {
        email.activityTemplateId = em.activityTemplateId;
        this.shareDocService.confirmModal(email, ModuleTypes.Immigration);
      }, "Share Documents", ModuleTypes.Immigration, false, this.attachmentShared);
    });
  }


  share(details: ImmigrationDocCombined) {
    this.loader.show();
    this.attachmentShared = [];
    const dName = details.fileName.split(".");
    details.fileName = details.documentName.replace("GPN_", '') + "." + dName[dName.length - 1];
    this.attachmentShared.push(details);
    this.emailAPI.getEmailMessageByCode("ShareDocument-IMM").pipe(finalize(() => {
      this.loader.clear();
    })).subscribe(em => {
      this.emailShare = this.shareDocService.mapToGeneralMail(em);
      this.emailShare.subject = "Document: " + details.documentTypeName;
      this.emailShare.uploadedFiles = this.attachmentShared;
      this.dialog.docShareMail(this.emailShare, (email) => {
        email.activityTemplateId = em.activityTemplateId;
        this.shareDocService.confirmModal(email, ModuleTypes.Immigration);
      }, "Share Documents", ModuleTypes.Immigration, true);
    });
  }

  AdditionalDocReq() {
    if (this.model.processor.id == null) {
      this.toast.warning("Please select the immigration consultant");
      return;
    }
    this.dialog.showAdditionalDocReq(this.model, this.visaType, this.countryType,
      (profile, reqList, requestorEmail) => {
        this.dialog.showConfirmationBox(
          "Confirm send mail"
          , `This will send a mail to "${requestorEmail}" to request additional documents from TMT portal. Do you really want to continue?`,
          () => {
            this.loader.show();
            this.immigrationApi.requestImmAdditionalDocuments(profile.id, this.model.processor.id, reqList).pipe((finalize(() => {
              this.loader.clear();
            }))).subscribe(resp => {
              this.toast.success("Request sent successfully");
            }, err => {
              this.toast.error("An error ocurred");
            });
          });
      });
  }


  configureComment(comment, type, profile) {
    const imComment = new ImmigrationComment();
    imComment.comment = comment.trim();
    imComment.profileId = profile.id;
    imComment.statusId = profile.immigrationStatus.id;
    imComment.commentType = type;
    return imComment;
  }



  getImmigrationCandidate(profile) {
    const model = new ImmigrationCandidate();
    model.init({
      profile: profile,
      countryCode: this.countryType,
      visaType: this.visaType,
      immigrationComment: new ImmigrationComment()
    });
    return model;
  }

  getImmigrationDocuments() {
    if (!this.isAdditionalUpload) {
      this.allFiles = [];
      let isApproverDocs = false;
      isApproverDocs = this.moduleType == DocTypes.REQUESTER_DOC ? false : true;
      this.model.id = this.common.immigrationProfileId;
      this.immigrationApi.getImmigrationDocuments(this.visaType, this.countryType, isApproverDocs, this.model).subscribe(resp => {

        this.allFiles = resp;
        this.uploadedCount = this.allFiles.filter(x => x.isUploaded).length;
        this.pendingAllCount = this.allFiles.length - (this.allFiles.filter(x => x.isUploaded).length);
        this.pendingCount = (this.allFiles.filter(x => x.mandatoryType == 1).length) - (this.allFiles.filter(x => x.mandatoryType == 1 && x.isUploaded).length);
        this.totalCount = this.allFiles.length;
        this.gridFiles = this.allFiles;
        this.getfileGrid(1);
        this.GetDocumentEvent.emit(resp);
      });
    }
    else {
      this.immigrationApi.getEligibleAdditionalDocuments(this.ImmigrationProfileId).subscribe(resp => {
        this.documentList = resp;//.sort((x, y) => (x.isMandatory === y.isMandatory) ? 0 : x.isMandatory ? -1 : 1);
        this.pendingCount = this.documentList.length;
        this.pendingAllCount = this.documentList.length;
        this.allFiles = resp;
        this.getfileGrid(1);
        this.GetDocumentEvent.emit(resp);
        this.validDocuments.emit(resp);
      });
    }
  }

  mandatoryCheck() {
    this.isMandatoryChecked = !this.isMandatoryChecked;
    this.getfileGrid(this.selectedTab);
  }

  getfileGrid(type: number) {

    if (!this.isAdditionalUpload) {

      this.selectedTab = 1;
      this.gridFiles = this.isMandatoryChecked ? this.allFiles.filter(x => x.mandatoryType == 1) : this.allFiles;

      this.allDoc = true;
      this.uploadedDoc = false;
      this.pendingDoc = false;

      if (type == 2) {
        this.selectedTab = 2;
        this.gridFiles = this.isMandatoryChecked ? this.allFiles.filter(x => x.mandatoryType == 1 && x.isUploaded) : this.allFiles.filter(x => x.isUploaded);
        this.allDoc = false;
        this.uploadedDoc = true;
        this.pendingDoc = false;
      } else if (type == 3) {
        this.selectedTab = 3;
        this.gridFiles = this.isMandatoryChecked ? this.allFiles.filter(x => x.mandatoryType == 1 && !x.isUploaded) : this.allFiles.filter(x => !x.isUploaded);
        this.allDoc = false;
        this.uploadedDoc = false;
        this.pendingDoc = true;

      }
    }
    else {
      this.gridFiles = this.allFiles.filter(x => x.additionalReqId != null && x.additionalReqId != 0);
    }

  }

  closeEdit(fileDetails) {
    let index = this.allFiles.findIndex(file => file.id === fileDetails.id);
    this.allFiles[index].isEditMode = false;
    this.editMode = false;   
  }

  getDocumentTypes() {

    this.docInstruction = null;
    if (!this.isAdditionalUpload) {
      this.form.resetForm();
      this.immigrationApi.getEligibleDocuments(this.visaType, this.countryType, this.isVisaApprover, this.model)
        .subscribe(resp => {
          this.documentList = resp.sort((x, y) => (x.isMandatory === y.isMandatory) ? 0 : x.isMandatory ? -1 : 1);
          this.validDocuments.emit(this.documentList);
        });
    } else {
      this.immigrationApi.getEligibleAdditionalDocuments(this.ImmigrationProfileId)
        .subscribe(resp => {
          this.documentList = resp.sort((x, y) => (x.isMandatory === y.isMandatory) ? 0 : x.isMandatory ? -1 : 1);
          this.validDocuments.emit(this.documentList);
        });
    }
  }

  getDocumentInstructions() {


    this.immigrationApi.getDocumentInstructions(this.visaType, this.model.id, this.isVisaApprover, nullSafeValue(() => this.model.nationality.id, 0))
      .subscribe(resp => {
        this.documentInstructions = resp;
      });
  }

  getUploadedFileDetails(id: number) {
    this.allFiles = [];
    if (!this.isAdditionalUpload) {
      this.immigrationApi.getDocumentDetails(id, this.moduleType).subscribe(resp => {
        this.allFiles = resp;
        this.GetDocumentEvent.emit(this.uploadedFiles);
      });
    } else {
      this.immigrationApi.getAllDocumentDetails(id).subscribe(resp => {
        this.allFiles = resp;
        this.GetDocumentEvent.emit(this.uploadedFiles);
      });
    }

  }

  changeDocumentName(docs: ImmigrationDocument[]): void {
    docs.forEach(doc => { doc.documentName = this.getDocName(doc.documentName) });
  } 

  isDocuploaded(item, type) {
    const mandatoryFileIds = this.documentList.filter(doc => doc.isMandatory).map(doc => doc.docNameId);
    const anyOneMandateIds = this.documentList.filter(doc => doc.mandatoryType > 1 && doc.docTypeId == item.docTypeId).map(doc => doc.docNameId);
    const uploadedFileIds = this.uploadedFiles.map(doc => doc.documentNameId);
    const bothMandateIds = this.documentList.filter(doc => doc.isMandatory && doc.docTypeId == item.docTypeId).map(doc => doc.docNameId);

    let res;
    if (type == 'docType') {
      if (anyOneMandateIds.length > 0) {
        res = anyOneMandateIds.some(id => uploadedFileIds.includes(id))
      }
      else if (bothMandateIds.length > 0) {
        res = bothMandateIds.every(id => uploadedFileIds.includes(id))
      }
    }

    if (type == 'docNameId') {
      res = uploadedFileIds.filter(x => x == item.docNameId).length > 0
    }

    if (item.docNameId == 6083) {
      res = false;
    }
    return res;

  }

  get getdistinctDocTypes(): DocumentType[] {
    this.distinctDocTypes = [];
    if (this.documentList && this.documentList.length > 0) {
      this.distinctDocTypes = this.documentList.filter(
        (docType, i, arr) => arr.findIndex(t => t.docTypeId === docType.docTypeId) === i);
    }
    return this.distinctDocTypes;
  }

  get documentTypes() {
    if (!this.documentList.length) { return [] }

    return this.documentList.filter(doc => doc.docTypeId === +this.fileDetails.documentTypeId);
  }

  get uploadedFiles(): Array<ImmigrationDocument> {
    if (!this.isAdditionalUpload) {
      return this.allFiles;
    } else {
      return this.allFiles.filter(x => (x.additionalReqId != null && x.additionalReqId != 0));
    }
  }

  get ifDocNotValid(): boolean {
    if (this.selectedDocument && (this.selectedDocument.size < this.MIN_FILE_SIZE || this.selectedDocument.size > this.MAX_FILE_SIZE)) {
      return true;
    }
    return false;
  }

  browseFile(doc) {    
    this.fileDetails.id = doc.id;
    this.fileDetails.documentTypeId = doc.documentTypeId;
    this.fileDetails.documentNameId = doc.documentNameId;
    this.fileDetails.documentName = doc.documentName
    this.fileDetails.fileName = doc.fileName;
    this.fileDetails.fileGuiId = doc.fileGuiId;
    this.fileDetails.description = doc.description;
    this.fileDetails.immigrationProfileId = this.common.immigrationProfileId;
    this.fileDetails.createdById = doc.createdById;
    this.fileDetails.moduleType = doc.moduleType;
    this.fileDetails.checks = doc.checks;
    this.fileDetails.additionalReqId = doc.additionalReqId;
    this.fileDetails.dependentId = doc.dependentId;
    this.fileDetails.synced = doc.synced;

    if (this.fileDetails.checks) {
      this.checkDocType = JSON.parse(this.fileDetails.checks)[0].Type;
      this.TMT_Check_Status = JSON.parse(this.fileDetails.checks)[0].Tmt_Check_Status;
      this.shouldUpdateFileInput = true;
    }

    setTimeout(() => {
      this.fileEle.nativeElement.click();
    }, 100);
  }

  get fileBrowserAllowedTypes() {
   
    if (this.shouldUpdateFileInput) {
    if (this.countryType === CountryTypesValues.UAE) {
      switch (this.checkDocType) {
        case ValidationDocType.ImageDocument:
          return AllowedDocumentFormat.UAEallowedImageMineTypes.join(',');
        case ValidationDocType.PDFDocument:
          return AllowedDocumentFormat.allowedDocumentMineTypes.join(',');

        default:
          return this.UaeAllowedMimeTypes.join(',');
      }

    } else {
      switch (this.checkDocType) {
        case ValidationDocType.ImageDocument:
          return AllowedDocumentFormat.allowedImageMineTypes.join(',');
        case ValidationDocType.PDFDocument:
          return AllowedDocumentFormat.allowedDocumentMineTypes.join(',');

        default:
          return this.allowedMimeTypes.join(',');
      }
    }
  }
  return '';
  }

  getDocName(docName: string) {
    if (!this.model.docPrefix) {
      return docName.replace("GPN_", '');
    }
    let docN = docName && docName.indexOf("GPN_") > -1 ?
      docName.replace("GPN", this.model.docPrefix) : `${this.model.docPrefix}_${docName}`;
    return docN;
  }

  getDocNameForGrid(doc: ImmigrationDocCombined) {
    let docName = doc.documentName;
    if (doc.dependentId !== null && doc.dependentId !== 0) {
      docName = docName + '_' + doc.dependentName;
    }
    return this.getDocName(docName);
  }

  fileSelected(files: FileList) {
    if (!files.item(0)) {
      return;
    }
    this.selectedDocument = files.item(0);

   
    if (this.selectedDocument.size < this.MIN_FILE_SIZE || this.selectedDocument.size > this.MAX_FILE_SIZE) {
      this.toast.error(`Invalid file size. File size should be between ${(this.MIN_FILE_SIZE / 1024).toFixed()} KB and ${(this.MAX_FILE_SIZE / 1024 / 1024).toFixed()} MB`);
      this.fileEle.nativeElement.value = null;
      return;
    }
    if (this.checkDocType == ValidationDocType.ImageDocument &&
      AllowedDocumentFormat.allowedImageMineTypes.indexOf(this.selectedDocument.type) < 0 ||
      this.checkDocType == ValidationDocType.PDFDocument &&
      AllowedDocumentFormat.allowedDocumentMineTypes.indexOf(this.selectedDocument.type) < 0 ||
      this.allowedMimeTypes.indexOf(this.selectedDocument.type) < 0) {
      this.toast.error(`Invalid file type. Please select a valid file`);
      this.fileEle.nativeElement.value = null;
      this.selectedDocument = null;
      this.element.nativeElement.value = "";
      return;
    }

    this.fileDetails.fileName = this.selectedDocument.name;

    if (this.fileDetails.checks) {
      this.checkDocType = JSON.parse(this.fileDetails.checks)[0].Type;
      this.TMT_Check_Status = JSON.parse(this.fileDetails.checks)[0].Tmt_Check_Status;
    }

    this.uploadDoc();

  }

  get selectedFileName(): string {
    return nullSafe(() => this.selectedDocument.name, '');
  }

  uploadDoc() {

    if (this.countryType === CountryTypesValues.UAE && !isNullOrUndefined(this.selectedDocument) && this.UaeAllowedMimeTypes.includes(this.selectedDocument.type) === false) {
      this.toast.error(`Please upload JPEG/JPG or PDF files only`);
      return;
    }

    if (this.ifDocNotValid) {
      this.toast.error(`Invalid file size. File size should be between
       ${(this.MIN_FILE_SIZE / 1024).toFixed()} KB and ${(this.MAX_FILE_SIZE / 1024 / 1024).toFixed()} MB`);
      return;
    }
    if (!this.editMode && isNullOrUndefined(this.selectedDocument)) {
      this.toast.warning("Please select a file!");
      return;
    }

    if (!this.editMode) {
      this.fileDetails.id = -1;
      this.fileDetails.createdById = this.authService.ActiveUser.employeeId;
    } else {
      this.fileDetails.modifiedById = this.authService.ActiveUser.employeeId;
    }
    if (this.selectedDocument != null) {
      this.fileDetails.fileName = this.selectedDocument.name;
    }
    this.upload();
  }

  IsFileUploadedForTask(docId: number, taskDocs, uploadedFiles: any[]): boolean {
    let uplodedDoc: number[] = uploadedFiles.map(obj => obj.documentNameId);
    uplodedDoc.push(docId);

    if (taskDocs != null) {
      return taskDocs.every(id => uplodedDoc.includes(id));
    }
    return true;
  }



  upload() {

    this.validationList = [];
    let docId = this.fileDetails.documentNameId
    this.fileDetails.immigrationProfileId = +this.common.immigrationProfileId;
    this.fileDetails.description = this.fileDetails.description ? this.fileDetails.description : '';
    this.fileDetails.moduleType = this.moduleType;
    this.disableUpload = true;
    this.loader.show();
    this.fileUploadService.postImmigrationFile(this.fileDetails, this.TMT_Check_Status, this.selectedDocument).pipe(finalize(() => {
      this.disableUpload = false;

    }))
      .subscribe(resp => {
        this.validationList = this.getDocValidationMessages(nullSafe(() => resp.data.documentChecks, []));
        if (resp.errorCode === 6001) {
          this.toast.error("File upload failed due to not meeting specifications!");
          //return
          this.loader.clear();
        }

        //this.updateAllFiles(resp.data);
        this.element.nativeElement.value = "";
        this.editMode = false;
        if (this.selectedDocument) {
          this.toast.success("File uploaded successfully!");
        } else {
          this.toast.success("Document details updated successfully!");
        }
        this.clearFormAndValidations(false);
        this.getImmigrationDocuments();
        this.loader.clear();
        this.shouldUpdateFileInput = false;
        this.checkDocType = 0;

      }, error => {
        this.loader.clear();
        this.toast.error("Something went wrong!");
        this.shouldUpdateFileInput = false;
        this.checkDocType = 0;
      });

    this.GetDocumentEvent.emit(this.uploadedFiles);
    if (this.IsFileUploadedForTask(docId, this.taskDocList, this.uploadedFiles)) {
      this.fileUploaded.emit(docId);
    } else {
      this.toast.warning("Please upload all specified document mentioned in task!");
    }

  }

  getDocValidationMessages(errorList: DocumentConfigLookupMapping[]) {
    let messages: DocumentValidationMessage[] = [];

    if (!errorList) {
      return [];
    }
    errorList.forEach(x => {
      if (x.isStrict) {
        const error: DocumentValidationMessage = {
          errorMessage: x.errorMessage,
          errorType: "Fail",
        };

        messages.push(error);
      }
      else {
        const error: DocumentValidationMessage = {
          errorMessage: x.errorMessage,
          errorType: "Warning",
        };

        messages.push(error);
      }
    });

    return messages;
  }

  updateAllFiles(resp: CandidateDocuments) {
    resp.documentType.lookupTypeId = this.lookupType;
    if (this.editMode) {
      this.allFiles.splice(this.allFiles.findIndex(file => file.id === resp.id), 1, resp);
    } else {
      this.allFiles.push(resp);
    }
  }

  clear(f: NgForm) {

    this.clearFormAndValidations();
  }

  clearFormAndValidations(clearValidation: boolean = true) {
    this.fileDetails.init({ documentTypeId: null, documentId: null, documentName: '' });
    this.selectedDocument = null;
    this.fileEle.nativeElement.value = null;
    this.editMode = false;
    this.docInstruction = null;
    if (clearValidation) {
      this.validationList = [];
    }

  }

  downloadDocument(details: ImmigrationDocument) {
    const filename = '';
    const doc = new ImmigrationDocument(details);
    doc.documentName = this.getDocName(details.documentName);
    this.fileUploadService.downloadImmigrationFile(doc, filename).subscribe(resp => {
      const extension = this.common.getFileExtension(doc.fileName);
      saveAs(resp, `${doc.documentName}${extension}`);
    },
      error => {
        Logger.error(error);
      });
  }

  downloadAll() {


    if (this.showSpinner) {
      return;
    }

    let typeId = -1;

    if (this.uploadedFiles.length <= 0 && this.lookupType === LookupTypeKeys.IMMIGRATION_DOCUMENT_TYPES) {
      this.toast.warning("No files to download!");
      return;
    }
    if (this.moduleType === DocTypes.REQUESTER_DOC) {
      typeId = this.moduleType;
    }
    this.showSpinner = true;
    this.fileUploadService.downloadAllImmigration(this.common.immigrationProfileId, typeId).pipe(finalize(() => {
      this.showSpinner = false;
    })).subscribe(resp => {
      // const gpn = !isNullOrUndefined(this.model.gpn) && this.model.gpn.length > 0 ? this.model.gpn : '';
      const gui = !isNullOrUndefined(this.model.gui) && this.model.gui.length > 0 ? this.model.gui : '';
      const docPrefix = !isNullOrUndefined(this.model.docPrefix) && this.model.docPrefix.length > 0 ?
        this.model.docPrefix : gui;

      const filenames: string[] = [docPrefix, this.model.firstName, this.model.lastName];
      const filename = filenames.filter(name => name !== '' && name !== null && name !== undefined).join('_');



      saveAs(resp, `${filename}.zip`);
    }, err => {
      Logger.error(err);
    });
  }

  downloadEmiratesID() {
    if (this.showFormSpinner) {
      return;
    }

    this.showFormSpinner = true;
    this.fileUploadService.downloadAttachmentFile("EmiratesIDDoc").pipe(
      finalize(() => {
        this.showFormSpinner = false;
      })
    ).subscribe(resp => {
      saveAs(resp, 'Emirates ID application form.pdf');
    },
      error => {
        Logger.error(error);
      });

  }

  edit(fileDetails) {
    let index = this.allFiles.findIndex(file => file.id === fileDetails.id);
    this.allFiles[index].isEditMode = true;
    this.editMode = true;
    // this.selectedDocName = new DocumentType();
    // const filteredVals = this.documentList.filter(t => t.docNameId == fileDetails.documentNameId);
    // if (filteredVals.length > 0) {
    //   this.selectedDocName = filteredVals[0];
    // }
    this.fileDetails.id = fileDetails.id;
    this.fileDetails.documentName = fileDetails.documentName;
    this.fileDetails.description = fileDetails.description;
    this.fileDetails.documentTypeId = fileDetails.documentType.id;
    this.fileDetails.fileName = fileDetails.fileName;
    this.fileDetails.fileGuiId = fileDetails.fileGuiId;
    this.fileDetails.immigrationProfileId = fileDetails.candidateProfileId;
    this.fileDetails.createdById = fileDetails.createdById;
    this.fileDetails.documentNameId = fileDetails.documentNameId;
    this.fileDetails.moduleType = this.moduleType;
    this.fileDetails.checks = fileDetails.checks;
    this.fileDetails.additionalReqId = fileDetails.additionalReqId;
    this.fileDetails.dependentId = fileDetails.dependentId;
    this.checkDocType = 0;
    //this.setCMDocInstruction();
  }

  delete(fileDetails) {
    this.dialog.showConfirmationBox('Confirm delete',
      'Are you sure you want to delete this file?',
      () => {
        this.immigrationApi.deleteFile(fileDetails).subscribe((resp) => {
          if (resp) {
            this.toast.success("Document deleted!");
          } else {
            this.toast.error("Document deletion failed!");
          }
          this.getImmigrationDocuments();
        });
      });

  }


  preview(details: ImmigrationDocument) {

    this.openfilepreview.getFilePreviewToken(details).then(token => {
      this.tryOpenInNativeApp(token, details);
    }).catch(err => {
    });
  }

  setCMDocTypes() {
    this.fileDetails.documentNameId = null;
    this.docInstruction = null;
    this.validationList = [];
    this.checkDocType = 0;
    const filteredVals = this.documentList.filter(t => t.docTypeId === this.fileDetails.documentTypeId);
    if (filteredVals.length === 1) {
      this.selectedDocName = new DocumentType();
      this.selectedDocName = filteredVals[0];
      this.fileDetails.documentNameId = filteredVals[0].docNameId;
      this.setCMDocInstruction();
    }
  }

  setCMDocInstruction() {
    if (this.selectedDocName != null) {
      this.fileDetails.documentNameId = this.selectedDocName.docNameId;
      if (!this.editMode) {
        this.fileDetails.additionalReqId = this.selectedDocName.additionalReqId;
      }
    }
    const filteredVals = this.distinctDocTypes.filter(t => t.docTypeId === this.fileDetails.documentTypeId);
    if (filteredVals.length > 0) {
      this.fileDetails.documentTypeId = filteredVals[0].docTypeId;
      ;
    }
    this.docInstruction = null;
    this.docInstruction = nullSafe(() => this.documentInstructions.filter(t => t.docNameId === this.fileDetails.documentNameId)[0].documentInstruction, '');
    this.fileDetails.checks = nullSafe(() =>
      this.documentList.find(dt => dt.docNameId == this.fileDetails.documentNameId).checks, "");
    if (this.fileDetails.checks) {
      this.checkDocType = JSON.parse(this.fileDetails.checks)[0].Type;
      this.TMT_Check_Status = JSON.parse(this.fileDetails.checks)[0].Tmt_Check_Status;
    }

  }

  tryOpenInNativeApp(token: string, details: CandidateDocuments) {
    const extension: string = details.fileName.split('.').pop();
    const doc = this.getDocName(details.documentName)
    this.docName = `${doc}.${extension}`;
    this.openfilepreview.previewFile(token, details.fileGuiId, this.docName).catch(r => {
      if (extension.toLowerCase() === 'pdf') {
        this.previewPDFFile(token, details);
      } else if (['png', 'jpg', 'jpeg'].indexOf(extension.toLowerCase()) > -1) {
        this.previewImageFile(token, details);
      }
    });
  }
  replaceGPNwithCode(docName: string) {
    let docN = docName && docName.indexOf("GPN_") > -1 ?
      docName.replace("GPN", "CC+GUI") : `${"CC+GUI"}_${docName}`
    return docN;
  }
  previewPDFFile(token: string, details: CandidateDocuments) {
    this.dialog.showPDFPreviewiew(this.openfilepreview.constructPDFUrl(token, this.docName), this.docName);
    // window.open(this.openfilepreview.constructPDFUrl(token, this.docName), '_blank');
  }

  previewImageFile(token: string, details: CandidateDocuments) {
    this.dialog.showImagePreview(this.openfilepreview.constructPDFUrl(token, this.docName), this.docName);
    // window.open(this.openfilepreview.constructPDFUrl(token, this.docName), '_blank');
  }

  get canAutoUpload(): boolean {
    return this.ImmigrationDataPopulation.validateModel(true, this.model);
  }

  pullDocsFromEmployeProfile() {
    if (!this.ImmigrationDataPopulation.validateModel(true, this.model)) {
      this.toast.warning('GPN and GUI are required to sync required documents');
      return;
    }

    this.loader.show();
    this.immigrationDatapull.pullDocumentsFromProfile(
      this.visaType,
      this.countryType,
      this.isVisaApprover,
      this.model
    ).pipe(
      finalize(() => this.loader.clear())
    ).subscribe(resp => {
      if (resp === 0) {
        this.toast.warning('No matching documents found');
        //this.toast.warning('Unable to sync documents. Either incorrect GPN, GUI or no documents found');
      } else {
        this.toast.success('Available files have been synced with TMT profile');
        //this.getUploadedFileDetails(this.model.id);
        this.getImmigrationDocuments();
      }

    }, err =>
      this.toast.error('Error in syncing with Employee profile')
    );

  }

  unlink(document: ImmigrationDocument) {
    this.loader.show();
    this.immigrationDatapull.unlinkSyncedImmigrationFile(document).pipe(
      finalize(() =>
        this.loader.clear()
      )
    ).subscribe(resp => {
      //this.getUploadedFileDetails(this.model.id);
      this.getImmigrationDocuments();
    }, err => this.toast.error('Error unlinking the document. Please try again'));

  }
  getDataTrim(data: DocumentType, length: number): string {
    const str = data.docTypeDisplayText;
    const isMandatory = (data.isMandatory || data.mandatoryType > 0) ? true : false;
    return textEllipsis(str, length, { isMandatory });
  }

  isEditable(item) {

    if (this.isAdditionalUpload) {
      return this.documentList.filter(x => x.additionalReqId == item.additionalReqId).length > 0;
    }
    return true;
  }

}

